// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// react
import { useEffect } from "react";
import { Alert } from "antd";

const PostCategoryHint = (props) => {
  const { prefs } = props;
  const value = prefs[`post_category_hint_${props.category.code}`];

  if (value) {
    return (
      <div style={{ textAlign: "justify" }}>
        <Alert message={value} type="warning" showIcon />
      </div>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state) => ({
  prefs: state.app.prefs,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {},
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostCategoryHint);
